import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import DevBanner from './components/DevBanner';
import DemoBanner from './components/DemoBanner';
import PreviewBanner from './components/PreviewBanner';

// Banner stack (top → bottom): DemoBanner > PreviewBanner > DevBanner.
//   · DemoBanner — highest stakes (canned results piped into public
//     widgets), warns the editor a sitewide demo-mode flag is on.
//   · PreviewBanner — flags a stuck phase-override (?phase=X) or
//     feature-flag bypass (?preview=1) so editors don't mistake their
//     local preview state for what readers actually see.
//   · DevBanner — environment marker (non-prod hosts).
// All three self-hide when their respective triggers are off, so
// public readers never see any of them.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <DemoBanner />
    <PreviewBanner />
    <DevBanner />
    <App />
  </React.StrictMode>,
);
